/**
 * Extraherar alla queryparametrar ur en querysträng.
 * @param {string} query 
 * @returns {object}
 */
export function getQueryParameters(query) {
    if (!query) {
        return {};
    }
  
    return (/^[?#]/.test(query) ? query.slice(1) : query)
        .split("&")
        .reduce((params, param) => {
            const [ key, value ] = param.split("=");
            params[key] = value ? decodeURIComponent(value.replace(/\+/g, " ")) : "";
            return params;
        }, {});
}